import utils from 'utils';
import { ToastNotification, Spinner } from 'components';
import React, { useEffect, useRef, useState } from 'react';

export const LazyLoadingWithPagination = (WrappedComponent, Promise, _args, _indexPrperty, Loader) => (props) => {

    const LazyLoadingComponent = () => {

        const [data, setData] = useState({ loading: false, result: null, error: null });
        const [paginationArgs, setpaginationArgs] = useState(_args);
        const [loaderPageItems, setLoaderPageItems] = useState();
        const [paginateItems, setPaginateItems] = useState(false);
        const toastRef = useRef();

        //INITIAL DATA FETCHING
        const initialFetching = () => {
            setData({ ...data, loading: true });
            Promise.apply(this, Object.values(paginationArgs)).then((response) => {
                setData({ result: response.result, loading: false });
                response.result.totalPages > 1 ? setPaginateItems(true) : setPaginateItems(false);
                setPaginateItems(true ? response.result.totalPages > 1 : false)
            }, error => {
                setData({ error: error, loading: false });
                toastRef?.current?.showToast({ type: "error", title: "Error", message: error });
            });
        }

        //FETCHING WITH LAZY PAGINATION 
        const lazyFetching = () => {
            setLoaderPageItems(true);
            Promise.apply(this, Object.values(paginationArgs)).then((response) => {
                let tempResult = data.result;
                tempResult[_indexPrperty] = data.result[_indexPrperty].concat(response.result[_indexPrperty]);
                setData({ ...data, result: tempResult });
                response.result.totalPages > paginationArgs.pageIndex ? setPaginateItems(true) : setPaginateItems(false);
            }, error => {
                setData({ error: error });
                toastRef?.current?.showToast({ type: "error", title: "Error", message: error });
            }).finally(() => setLoaderPageItems(false));
        }

        useEffect(() => {
            utils.fullFilledArrayArguments(Object.values(paginationArgs)) && initialFetching();
        }, []);

        useEffect(() => {
            (paginationArgs.pageIndex !== 0) && lazyFetching();
        }, [paginationArgs.pageIndex]);


        return (
            <div style={{ minHeight: '75vh', position: 'relative' }}>
                {
                    data.loading ? Loader :
                        data.result &&
                        <WrappedComponent {...props} data={data.result} >
                            {
                                paginateItems &&
                                <div className="text-center p-2">
                                    {!loaderPageItems ?
                                        <button type="button" className="btn btn-secondary btn-sm" onClick={() => { setpaginationArgs({ ...paginationArgs, pageIndex: paginationArgs.pageIndex + 1 }) }} >
                                            <i className="bi bi-arrow-clockwise" /> See more</button> : <Spinner />
                                    }
                                </div>
                            }
                        </WrappedComponent>
                }

                <ToastNotification ref={toastRef} />
            </div>
        );


    }

    return LazyLoadingComponent;
}